const d = new Date();
export const yearNow = d.getFullYear();